import React, { Component } from "react";
import Functions from "../../src/functions";

class Hidden extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.editable = this.editable.bind(this);
    this.nonEditable = this.nonEditable.bind(this);
    this.customUI = this.customUI.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    this.state = {
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
    };
  }

  componentDidMount() {
    this.setState({
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  editable() {
    let control = (
      <input
        type="hidden"
        defaultValue={this.state.defaultValue}
        placeholder={this.state.placeholder}
        name={this.state.name}
        {...this.state.attributes}
        {...this.state.events}
      ></input>
    );

    return this.customUI(control);
  }

  nonEditable() {
    let control = this.state.defaultValue;

    return this.customUI(control);
  }

  render() {
    if (this.state.loaded) {
      let control = this.state.editable ? this.editable() : this.nonEditable();

      return control;
    }
    return "";
  }
}

export default Hidden;
